import { Link } from "react-router-dom";
import { Flame, Plus, ArrowRight } from "lucide-react";
import { CATEGORIES, ASSETS } from "@/config/categories";
import { tempColor } from "@/components/public/TemperatureBadge";

export const HotDealsWidget = ({ deals = [] }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm" data-testid="hot-deals-widget">
    <div className="flex items-center gap-2 mb-4">
      <Flame className="h-5 w-5 text-[#FF3B30]" />
      <h3 className="font-outfit font-bold text-slate-900">Heißeste Deals</h3>
    </div>
    <div className="space-y-1">
      {deals.slice(0, 5).map((d, i) => (
        <Link key={d.id} to={`/deal/${d.id}`} className="flex items-center gap-3 p-2 -mx-2 rounded-xl hover:bg-slate-50 transition-colors group">
          <span className="font-outfit font-black text-slate-300 w-4 text-center text-sm">{i + 1}</span>
          <img src={d.image_url || "/wizard-icon.png"} alt="" className="h-11 w-11 rounded-lg object-cover bg-slate-50 border border-slate-100" />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-slate-800 truncate group-hover:text-pink-500 transition-colors">{d.product_name}</p>
            <p className="text-xs text-slate-400">{d.deal_price.toFixed(2)} €</p>
          </div>
          <span className="font-outfit font-black text-sm shrink-0" style={{ color: tempColor(d.temperature) }}>{d.temperature}°</span>
        </Link>
      ))}
    </div>
  </div>
);

export const CategoriesWidget = ({ counts = {} }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm" data-testid="categories-widget">
    <h3 className="font-outfit font-bold text-slate-900 mb-4">Top Kategorien</h3>
    <div className="grid grid-cols-2 gap-2">
      {CATEGORIES.slice(0, 8).map((c) => {
        const Icon = c.icon;
        return (
          <Link key={c.name} to={`/kategorie/${encodeURIComponent(c.name)}`} className="flex items-center gap-2 p-2 rounded-xl hover:bg-slate-50 transition-colors group">
            <div className="h-8 w-8 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: `${c.color}15` }}>
              <Icon className="h-4 w-4" style={{ color: c.color }} />
            </div>
            <span className="text-xs font-semibold text-slate-700 truncate group-hover:text-slate-900">{c.name}</span>
          </Link>
        );
      })}
    </div>
  </div>
);

export const PromoCard = () => (
  <div className="relative overflow-hidden bg-slate-900 rounded-2xl p-6 shadow-sm" data-testid="promo-card">
    <img src={ASSETS.magicBox} alt="" className="absolute -right-4 -bottom-4 h-28 w-28 object-contain opacity-90 pointer-events-none" />
    <div className="relative">
      <h3 className="font-outfit font-black text-white text-lg leading-tight">Kennst du einen<br />heißen Deal? 🪄</h3>
      <p className="text-slate-300 text-sm mt-1.5 mb-4 max-w-[70%]">Teile ihn mit der Community und werde zum Zauberer.</p>
      <Link to="/deal-einreichen" className="inline-flex items-center gap-1.5 bg-white text-slate-900 font-outfit font-bold rounded-full px-4 py-2 text-sm hover:bg-slate-100 active:scale-95 transition-all">
        <Plus className="h-4 w-4" /> Deal posten
      </Link>
    </div>
  </div>
);

export const CommunityWidget = ({ totalDeals = 0 }) => (
  <div className="bg-gradient-to-br from-[#A259FF]/10 via-[#FF62A5]/10 to-[#FF8A3D]/10 rounded-2xl border border-pink-100 p-5" data-testid="community-widget">
    <h3 className="font-outfit font-bold text-slate-900 mb-1">Werde Teil der Magie</h3>
    <p className="text-sm text-slate-600 mb-3">Stimme ab, kommentiere & reiche eigene Deals ein.</p>
    <Link to="/registrieren" className="inline-flex items-center gap-1 text-sm font-bold text-pink-600 hover:gap-2 transition-all">
      Jetzt registrieren <ArrowRight className="h-4 w-4" />
    </Link>
  </div>
);
